import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Generated class for the ModalHeaderComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'modal-header',
  templateUrl: 'modal-header.html'
})
export class ModalHeaderComponent {
  @Input() leftText: string;
  @Input() rightText: string = '';

  @Output() leftCallBack = new EventEmitter();
  @Output() rightCallBack = new EventEmitter();

  constructor() {

  }

  leftButton() {
    this.leftCallBack.emit();
  }

  rightButton() {
    if (this.rightCallBack) {
      this.rightCallBack.emit();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/modal-header/modal-header.ts